// Auto-register the FCM token when a staff member is signed in with a
// selected club. Runs once per (uid × clubId) pair — if the user switches
// clubs, we re-register against the new staff doc.

import { useEffect, useRef } from 'react'
import { useAuthStore } from '@/core/auth/auth-store'
import { useCurrentClubStore } from '@/core/auth/current-club-store'
import { ensureFcmRegistration } from './register-fcm'
import { logger } from '@/core/logger'

export function useFcmAutoRegister(): void {
  const user = useAuthStore((s) => s.user)
  const clubId = useCurrentClubStore((s) => s.clubId)
  const uid = user?.uid ?? null
  const attemptedKey = useRef<string | null>(null)

  useEffect(() => {
    if (!user || !clubId || !uid) return
    const vapidKey = import.meta.env['VITE_FIREBASE_VAPID_KEY'] as string | undefined
    if (!vapidKey) {
      logger.i('FCM: VITE_FIREBASE_VAPID_KEY not set — push notifications disabled')
      return
    }
    const key = `${clubId}:${uid}`
    if (attemptedKey.current === key) return
    attemptedKey.current = key
    void ensureFcmRegistration({ clubId, uid, vapidKey }).catch((err) => {
      logger.w('FCM auto-register error', err)
    })
  }, [user, clubId, uid])
}
